<template>
    <b-row>
        <b-col cols="12"
               class="sub-tabs"
        >
            <b-tabs content-class="mt-3"
                    v-model="tab"
                    fill
                    lazy
            >
                <b-tab title="Gases Inflamables"
                       active
                       no-body
                       lazy
                >
                    <b-button-group>
                        <b-button :variant="!tab_1 ? 'primary' : 'secondary'"
                                  class="mb-2"
                                  @click="tab_1 = 0"
                        >
                            GASES INFLAMABLES
                        </b-button>
                        <b-button :variant="tab_1 ? 'primary' : 'secondary'"
                                  class="mb-2"
                                  @click="tab_1 = 1"
                        >
                            CLASIFICACIÓN MEZCLAS
                        </b-button>
                    </b-button-group>

                    <answers v-if="tab_1 === 0"
                             ref="answers"
                             code_question_group="GQ16"
                             danger_code="MCAL02"
                             :unique_category="true"
                    >
                        <template slot="alert"
                                  v-if="isStateAllowed"
                        >
                            <b-row class="mt-1">
                                <b-col>
                                    <b-alert show
                                             variant="info"
                                             class="mb-2"
                                    >
                                        <div class="d-flex align-items-start">
                                            <i class="fa fa-info-circle mr-2 mt-1"></i>
                                            <div>
                                                <p class="my-0">
                                                    Para clasificar una mezcla de gas inflamable sin datos de
                                                    propiedades
                                                    físico-químicas, elija "Clasificación de mezclas" (según la
                                                    norma ISO
                                                    10156:2010).
                                                </p>
                                            </div>
                                        </div>
                                    </b-alert>
                                </b-col>
                            </b-row>
                        </template>
                    </answers>

                    <form_mode v-else/>
                </b-tab>

                <b-tab title="Gases pirofóricos"
                       no-body
                >
                    <answers v-if="tab === 1" ref="answers"
                             code_question_group="GQ17"
                             danger_code="MCAL40"
                    />
                </b-tab>

                <b-tab title="Gases químicamente inestables">
                    <answers v-if="tab === 2"
                             ref="answers"
                             code_question_group="GQ18"
                             danger_code="MCAL03"
                             :unique_category="true"
                    />
                </b-tab>
            </b-tabs>
        </b-col>
    </b-row>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import answers from '../../../components/answers.vue';
import form_mode from './form_mode.vue';
import Classification from "../../../components/classification.vue";

export default {
    name: 'index',
    components: {
        Classification,
        answers,
        form_mode
    },
    data() {
        return {
            tab: 0,
            tab_1: 0
        };
    },
    computed: {
        ...mapState('calculator', [
            'product',
            'classification'
        ]),
        ...mapGetters('calculator', [
            'isStateAllowed'
        ])
    },
};
</script>


<style lang="scss"
       src="../../../../../assets/calculator.scss"
/>
